export default __webpack_public_path__ + "static/media/editBtn.ee4a50b9.svg";